import { render, staticRenderFns } from "./vueCustomScrollbar.vue?vue&type=template&id=2c9ced56&"
import script from "./vueCustomScrollbar.vue?vue&type=script&lang=js&"
export * from "./vueCustomScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./vueCustomScrollbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports